<template>
  <div class="dashboard-container">
    <div class="dashboard-header">
      <h1 class="dashboard-title">系統管理 Dashboard</h1>
      <p class="dashboard-subtitle">歡迎回來，{{ (user && user.name) || (user && user.username) || '' }}</p>
    </div>

    <div class="dashboard-content">
      <div class="info-cards">
        <div class="info-card">
          <div class="info-card-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="ri-user-line"></i>
          </div>
          <div class="info-card-content">
            <h3>帳號類型</h3>
            <p>{{ (user && user.accountType) || 'system' }}</p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-card-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
            <i class="ri-checkbox-circle-line"></i>
          </div>
          <div class="info-card-content">
            <h3>有效客戶</h3>
            <p>{{ stats.activeClientCount || 0 }}</p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-card-icon" style="background: linear-gradient(135deg, #fbc531 0%, #f39c12 100%);">
            <i class="ri-alarm-warning-line"></i>
          </div>
          <div class="info-card-content">
            <h3>請款提醒/寬限期</h3>
            <p>{{ stats.dueSoonAndGracePeriodCount || 0 }}</p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-card-icon" style="background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);">
            <i class="ri-error-warning-line"></i>
          </div>
          <div class="info-card-content">
            <h3>逾期（超過寬限期）</h3>
            <p>{{ stats.overdueCount || 0 }}</p>
          </div>
        </div>
      </div>

      <div class="dashboard-section">
        <h2>快速功能</h2>
        <div class="quick-actions">
          <button class="quick-action-btn" @click="$router.push('/system/clients')">
            <i class="ri-group-line"></i>
            <span>客戶資料</span>
          </button>
          <button class="quick-action-btn" @click="$router.push('/system/clients/accounts')">
            <i class="ri-user-settings-line"></i>
            <span>客戶帳號管理</span>
          </button>
          <button class="quick-action-btn" @click="$router.push('/system/platforms/accounts')">
            <i class="ri-building-line"></i>
            <span>平台帳號管理</span>
          </button>
          <button class="quick-action-btn" @click="$router.push('/system/modules')">
            <i class="ri-apps-line"></i>
            <span>模組管理</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import authService from '@/helpers/authservice/authService.js';
import { clientService } from '@/api/modules/clients.js';

export default {
  name: 'SystemDashboard',
  setup() {
    const user = ref(null);
    const stats = ref({
      activeClientCount: 0,
      dueSoonAndGracePeriodCount: 0,
      overdueCount: 0
    });
    const loading = ref(false);

    const fetchClientStats = async () => {
      try {
        loading.value = true;
        const response = await clientService.getClientStats();
        if (response && response.success && response.data) {
          stats.value = {
            activeClientCount: response.data.activeClientCount,
            dueSoonAndGracePeriodCount: response.data.dueSoonAndGracePeriodCount,
            overdueCount: response.data.overdueCount
          };
        }
      } catch (error) {
        // 獲取客戶統計資訊失敗
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      user.value = authService.getCurrentUser();
      fetchClientStats();
    });

    return {
      user,
      stats,
      loading,
    };
  },
};
</script>

<style scoped>
.dashboard-container {
  padding: 0;
}

.dashboard-header {
  margin-bottom: 20px;
}

.dashboard-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.dashboard-subtitle {
  font-size: 16px;
  color: #666;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 20px;
}

.info-card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.info-card-content h3 {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
}

.info-card-content p {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.dashboard-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dashboard-section h2 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.quick-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.quick-action-btn {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.quick-action-btn:hover {
  border-color: #667eea;
  background: #f8f9ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.quick-action-btn i {
  font-size: 32px;
  color: #667eea;
}

.quick-action-btn span {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
</style>
